import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client.js';
import type { ModelSummary, Tag } from '@wml-crm/shared';

function firstLetter(s: string): string {
  const c = s.trim().charAt(0);
  return c ? c.toUpperCase() : '?';
}

export function ModelsListPage() {
  const [models, setModels] = useState<ModelSummary[]>([]);
  const [tags, setTags] = useState<Tag[]>([]);
  const [q, setQ] = useState('');
  const [selectedTag, setSelectedTag] = useState<string>(''); // фильтр по имени тега

  useEffect(() => {
    api<ModelSummary[]>('/api/models').then(setModels).catch(() => setModels([]));
    api<Tag[]>('/api/tags').then(setTags).catch(() => setTags([]));
  }, []);

  const filtered = useMemo(() => {
    let out = models;
    if (selectedTag) {
      out = out.filter((m) => (m.tags ?? []).includes(selectedTag));
    }
    if (q) {
      const needle = q.toLowerCase();
      out = out.filter((m) => m.displayName.toLowerCase().includes(needle));
    }
    return out;
  }, [models, q, selectedTag]);

  return (
    <div className="home-inner">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 24, gap: 16, flexWrap: 'wrap' }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700, letterSpacing: '-0.025em' }}>Все модели</h1>
          <div style={{ color: 'var(--text-subtle)', fontSize: 13, marginTop: 4 }}>
            {models.length} моделей в системе · показано {filtered.length}
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <select
            className="admin-input"
            value={selectedTag}
            onChange={(e) => setSelectedTag(e.target.value)}
            style={{ width: 180 }}
            title="Фильтр по тегу"
          >
            <option value="">Все теги</option>
            {tags.map((t) => (
              <option key={t.id} value={t.name}>
                {t.name}{typeof t.modelCount === 'number' ? ` (${t.modelCount})` : ''}
              </option>
            ))}
          </select>
          <input
            className="admin-input"
            placeholder="Фильтр по имени…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            style={{ width: 260 }}
          />
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="empty-state">
          <div style={{ fontSize: 28, marginBottom: 8, opacity: 0.6 }}>🔍</div>
          <div>Ничего не найдено</div>
        </div>
      ) : (
        <div className="model-grid">
          {filtered.map((m) => (
            <Link key={m.id} to={`/model/${m.id}`} className="model-card">
              <div className="model-avatar">{firstLetter(m.displayName)}</div>
              <div className="info">
                <div className="name">{m.displayName}</div>
                <div className="meta">{m.accountCount} акк. · {m.postCount} постов</div>
                {(m.tags ?? []).length > 0 && (
                  <div className="model-card-tags">
                    {(m.tags ?? []).slice(0, 3).map((t) => (
                      <span key={t} className="model-card-tag">{t}</span>
                    ))}
                    {(m.tags ?? []).length > 3 && (
                      <span className="model-card-tag">+{(m.tags ?? []).length - 3}</span>
                    )}
                  </div>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
